import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug, sortObjectsByAlphabet } from "../../utils";
import * as centralCredentialsService from "./centralCredentialsService";
import * as modalDataService from "./modalDataService";
import SelectV2 from "../../view/SelectV2";

function CentralCredentialsField({ centralCredentials, centralCredentialId, disabled }) {


    useEffect(() => {
        centralCredentialsService.list();
            // .then((data) =>
            //     !centralCredentialId
            //     && data
                // && modalDataService.changeCentralCredential(data.find(
                //     centralCredential => centralCredential.id === Number(data[0].id)))
            // );
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (value) => {
        const centralCredential = centralCredentials.find(centralCredential => String(centralCredential.id) === String(value));
        modalDataService.changeCentralCredential(centralCredential)
    };

    const centralCredentialsCopy = sortObjectsByAlphabet(centralCredentials, 'ccname');
    const centralCredentialOptions = centralCredentialsCopy.map((centralCredential) => ({
        value: centralCredential.id,
        label: centralCredential.ccname
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="centralCredential" className="label-central-credentials">Central Credential</label>
                <SelectV2
                    inputId="centralCredential"
                    value={centralCredentialId}
                    onChange={onChange}
                    options={centralCredentialOptions}
                    isDisabled={disabled}
                    placeholder="Choose"
                />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("GroupField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const centralCredential = addDeviceModal.centralCredential;
    return {
        centralCredentials: addDeviceModal.centralCredentials || [],
        centralCredentialId: centralCredential ? centralCredential.id : null
    };
}

export default connect(mapStateToProps)(CentralCredentialsField);
